import { MouseTrackerTypes } from "../types/mouseTracker.types";

export const MouseTrackerState: MouseTrackerTypes = {
  hoveredFigure: false,
  name: "",
};
